import { render, staticRenderFns } from "./MasterTipePinjaman.vue?vue&type=template&id=772ae51c&scoped=true&"
import script from "./MasterTipePinjaman.vue?vue&type=script&lang=js&"
export * from "./MasterTipePinjaman.vue?vue&type=script&lang=js&"
import style0 from "./MasterTipePinjaman.vue?vue&type=style&index=0&id=772ae51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ae51c",
  null
  
)

export default component.exports